import { KontentLoginForms } from "../components/blocks/LoginForm";
import { formatLinks } from "./links";

export function formatLoginForms(form: KontentLoginForms) {
  return form?.value?.map((form) => {
    const codename = form.elements.login_method.value[0].codename;
    let label = form.elements.login_method.value[0].name || "";
    let link;

    if (
      codename === "custom_sign_in" &&
      form.elements.link_configuration__link.modular_content.length > 0
    ) {
      link = formatLinks(
        form.elements.link_configuration__link.modular_content
      )[0];
      label = link?.label;
    }

    if (codename === "digital_banking") {
      label = "Digital Banking";
    }

    if (codename === "e_business") {
      label = "E-Business";
    }

    return {
      formType: codename,
      formLabel: label,
      message: form.elements.offline_message.value,
      url: link?.href,
    };
  });
}
